module.exports = __webpack_public_path__ + "img/store-sqlserver.b93d3584.svg";